<template>
	<rr-menu :items="items" :class="$style['social-links-menu']"/>
</template>

<script>
import scrollAnimation from './rr/mixins/scroll-animation'
import SocialLinks from './SocialLinks'

export default {
	name: 'AnimateSocialLinks',
	mixins: [scrollAnimation],
	extends: SocialLinks,
	// props: {
	// 	textType: {
	// 		type: String,
	// 	},
	// },
	methods: {
		buildScrollTl() {
			// start label
			this.scrollTl.add('s')

			// variables
			const is = this.$el.querySelectorAll('li')

			is.forEach((node, index) => {
				this.scrollTl.fromTo(node, .83, {
					y: 35,
					opacity: 0,
					// transformOrigin: 'center',
					// z: 10,
					// force3D: true,
				}, {
					y: 0,
					opacity: 1,
					ease: 'ease',
				}, 's+='+index*.13)
			})
		},
	},
	watch: {},
}
</script>
